import React, { useState, useEffect } from 'react';
//import './navbar.css';
//import { Link } from "react-router-dom"
import { Form } from 'react-bootstrap';
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";



const Cerca_una_ditta = (props) => {
//    const [somma, calcola_somma] = useState('');
    const [input, setInput] = useState({})
    const { user, isAuthenticated } = useAuth0();

    useEffect(() => {

       if (props.ricerca_ditta) {
           cerca_ditte_tramite_sottostringa (input.stringa)
       }
        
    }, [props.variab_aggiorna]);



    function handleChange (event) {
        const { name, value } = event.target;
        console.log('sssssss')
        console.log(event.target)
        setInput(prevInput => {
            return {
                ...prevInput,
                [name]: value
            }
        })
        var utente = 'utente_unico'
        let sottostringa = value 
        
        console.log(input)

        cerca_ditte_tramite_sottostringa (sottostringa)
        if (value.length > 0) {props.SET_ricerca_ditta(true)}

    }

    function cerca_ditte_tramite_sottostringa (sottostringa) {
        var utente = 'utente_unico'
        console.log(sottostringa)
    
        axios.get('/ditte/ricerca_ditte/' + utente + '/' + sottostringa + '/' + user.email)
        .then((res) => {
            console.log('Ditte ricercate fecciate da mongo')
            console.log(res.data)
    
            props.SET_lista_ditte(res.data)
        }).catch((error) => {
            console.log(error)
        });
   
    }
    

    return (
    <>
     {!props.boolean_lista_ditte  && <>   
       
     <Form>
      <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
        <Form.Label>Ricerca una ditta</Form.Label>
        <Form.Control type="text" name="stringa" placeholder="Ragione sociale / Partita Iva" onChange={handleChange}/>
      </Form.Group>
    </Form>
    </>}
    </>
    )
}
export default Cerca_una_ditta;